function formatDateElement(dateElement, language) {
   const date = new Date(dateElement.dateTime);
   dateElement.textContent = date.toLocaleString(language, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
   });
}

function formatDates() {
   // Load language from HTML
   const htmlElement = document.querySelector('html');
   const language = htmlElement.lang;
   // Find `time` elements
   const dateElements = document.querySelectorAll('time');
   // Format dates
   dateElements.forEach((dateElement) => formatDateElement(dateElement, language));
}

formatDates();
